var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0001 18.7999L15.0001 8.41992",
    stroke: "#CECFD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0001 31.9998V15.9998C41.9994 15.2984 41.8142 14.6094 41.4632 14.0021C41.1122 13.3948 40.6076 12.8905 40.0001 12.5398L26.0001 4.5398C25.392 4.18873 24.7023 4.00391 24.0001 4.00391C23.298 4.00391 22.6082 4.18873 22.0001 4.5398L8.00012 12.5398C7.39265 12.8905 6.88808 13.3948 6.53705 14.0021C6.18601 14.6094 6.00084 15.2984 6.00012 15.9998V31.9998C6.00084 32.7013 6.18601 33.3902 6.53705 33.9975C6.88808 34.6048 7.39265 35.1091 8.00012 35.4598L22.0001 43.4598C22.6082 43.8109 23.298 43.9957 24.0001 43.9957C24.7023 43.9957 25.392 43.8109 26.0001 43.4598L40.0001 35.4598C40.6076 35.1091 41.1122 34.6048 41.4632 33.9975C41.8142 33.3902 41.9994 32.7013 42.0001 31.9998Z",
    stroke: "#CECFD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54004 13.9199L24 24.0199L41.46 13.9199",
    stroke: "#CECFD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 44.16V24",
    stroke: "#CECFD1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.9fca33cbda2b59a13e03690248de36a9.svg";
export { ForwardRef as ReactComponent };